import { render } from "./marker-detail.vue?vue&type=template&id=abab9df4&scoped=true"
import script from "./marker-detail.vue?vue&type=script&lang=js"
export * from "./marker-detail.vue?vue&type=script&lang=js"

import "./marker-detail.vue?vue&type=style&index=0&id=abab9df4&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\YDN\\trunk\\zulin-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abab9df4"]])

export default __exports__